import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Observable } from "rxjs/Observable";
import { Employee } from "../models/employee.model";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Pagination } from "../models/pagination.model";

@Injectable()
export class SearchFormService {

    constructor(private apiService: ApiService) { }

    searchEmployee(value: string): Observable<Pagination> {
        return this.apiService.get('employees/search' + '?query=' + value);
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/search-form.service.ts